import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { params, string, shape, bool } from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import './moving-calculator.scss';

const MovingCalculator = ({ itemId }) => {

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('moving-calculator.ready'); }, []);

  const { data, loading, error } = useProductDeprecated({ itemId, domains: ['info'] });
  // const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (!data || loading || (error && !data)) {
    return null;
  }

  const { movingCalculatorEligible } = data.product.info || {};
  if (!movingCalculatorEligible) return null;

  return (
    <div className="moving-calculator__wrapper">
      <div className="moving-calculator__text">
        <img
          className="moving-calculator__icon"
          src="http://assets.homedepot-static.com/images/v1/calculator-orange.svg"
          alt="calculator icon"
        />
        <div>
          <div className="moving-calculator__text--header">
            Getting ready for your move?
          </div>
          <div className="moving-calculator__text--body">
            Calculate how many supplies you need
          </div>
        </div>
      </div>
      <div className="moving-calculator__button-wrapper">
        <a href="//hdmoving.com/" className="bttn-outline bttn-outline--dark">
          <span className="bttn__content">
            Calculate Now
          </span>
        </a>
      </div>
    </div>
  );
};

MovingCalculator.displayName = 'MovingCalculator';

MovingCalculator.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    info: shape({
      movingCalculatorEligible: bool()
    })
  })
};

MovingCalculator.propTypes = {
  itemId: PropTypes.string,
};

MovingCalculator.defaultProps = {
  itemId: null
};

export { MovingCalculator };
